var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/ui/card/card.tsx";
const _excluded = ["children", "variant", "size", "className"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import classNames from 'clsx';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { Text } from 'soapbox/components/ui';
import SvgIcon from 'soapbox/components/ui/icon/svg-icon';
const sizes = {
  md: 'p-4 sm:rounded-xl',
  lg: 'p-4 sm:p-6 sm:rounded-xl',
  xl: 'p-4 sm:p-10 sm:rounded-3xl'
};
const messages = defineMessages({
  back: {
    "id": "card.back.label",
    "defaultMessage": "Back"
  }
});

/** An opaque backdrop to hold a collection of related elements. */
const Card = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    children,
    variant = 'default',
    size = 'md',
    className
  } = _ref,
      filteredProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("div", _extends({
    ref: ref
  }, filteredProps, {
    className: classNames({
      'bg-white dark:bg-primary-900 text-gray-900 dark:text-gray-100 shadow-lg dark:shadow-none overflow-hidden isolate': variant === 'rounded',
      [sizes[size]]: variant === 'rounded'
    }, className),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 32,
      columnNumber: 3
    }
  }), children);
});

/**
 * Card header container with back button.
 * Typically holds a CardTitle.
 */
const CardHeader = _ref2 => {
  let {
    children,
    backHref,
    onBackClick
  } = _ref2;
  const intl = useIntl();

  const renderBackButton = () => {
    if (!backHref && !onBackClick) {
      return null;
    }

    const Comp = backHref ? Link : 'button';
    const backAttributes = backHref ? {
      to: backHref
    } : {
      onClick: onBackClick
    };
    return /*#__PURE__*/React.createElement(Comp, _extends({}, backAttributes, {
      className: "mr-2 text-gray-900 dark:text-gray-100 focus:ring-primary-500 focus:ring-2",
      "aria-label": intl.formatMessage(messages.back),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 65,
        columnNumber: 7
      }
    }), /*#__PURE__*/React.createElement(SvgIcon, {
      src: require('@tabler/icons/arrow-left.svg'),
      className: "h-6 w-6",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 66,
        columnNumber: 9
      }
    }), /*#__PURE__*/React.createElement("span", {
      className: "sr-only",
      "data-testid": "back-button",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 67,
        columnNumber: 9
      }
    }, intl.formatMessage(messages.back)));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "mb-4 flex flex-row items-center",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 73,
      columnNumber: 5
    }
  }, renderBackButton(), children);
};

/** A card's title. */
const CardTitle = _ref3 => {
  let {
    title
  } = _ref3;
  return /*#__PURE__*/React.createElement(Text, {
    size: "xl",
    weight: "bold",
    tag: "h1",
    "data-testid": "card-title",
    truncate: true,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 87,
      columnNumber: 3
    }
  }, title);
};
/** A card's body. */


const CardBody = _ref4 => {
  let {
    children
  } = _ref4;
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "card-body",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 92,
      columnNumber: 3
    }
  }, children);
};

export { Card, CardHeader, CardTitle, CardBody };